import { OrderError } from '../../../../sections/OrderEditSections.types';
import { indexViolationsByItem } from '../businessPolicyViolation.utils';
import { useBusinessPolicyViolationViews } from './useBusinessPolicyViolationViews';

export const useOrderProductsBusinessPolicyViolations = (businessPolicyErrors?: OrderError) => {
  const violations = useBusinessPolicyViolationViews(
    businessPolicyErrors ? [businessPolicyErrors] : [],
  );

  return { violations, byItemKey: indexViolationsByItem(violations) };
};
